import Em from 'ember';
export default Em.Component.extend({
  classNames: ['ic-popup', 'ic-popup-left', 'ic-popup-short', 'is-light-theme', 'composer-social-inserter'],
  actions: {
    switchMode(mode) {
      this.set('mode', mode);
    }
  }
});